import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { CLIENT_CHATBOT } from "src/containers/layout";
import useFormatById from "src/hooks/utils/useFormatById";
import { ReactComponent as GroupYellowIcon } from "src/assets/static/images/header/group.svg";

const DesktopMenuOptions = ({
  dropdownRef,
  activeMenu = null,
  closeMenu = () => {},
}) => {
  const lang = useSelector((state) => state.common.lang);
  const f = useFormatById();
  const imedilLink = process.env.REACT_APP_CLIENT_MAIN_URL;
  const profileLink = process.env.REACT_APP_IMEDIL_LINK;

  return (
    <>
      {activeMenu && <div className="dark-overlay opened"></div>}
      {activeMenu === 1 && (
        <div
          className="header-dropdown"
          ref={dropdownRef}
          onMouseLeave={closeMenu}
        >
          <div className="dropdown-col">
            <h3>{f("topbar.forYou")}</h3>
            <Link
              className="white-link"
              to={`/car/${lang}`}
              onClick={() => closeMenu()}
            >
              {f("topbar.autoInsurance")}
            </Link>
            <Link
              className="white-link"
              to={`/uno/${lang}`}
              onClick={() => closeMenu()}
            >
              {f("topbar.HealthInsurance")}
            </Link>
            <Link
              className="child-link"
              to={`/uno-active/${lang}`}
              onClick={() => closeMenu()}
            >
              <GroupYellowIcon /> {f("topbar.unoActive")}
            </Link>
            {/* <Link
              className="child-link"
              to={`/uno-comfort/${lang}`}
              onClick={() => closeMenu()}
            >
              <GroupYellowIcon /> {f("topbar.unoComfort")}
            </Link> */}
            {/* <Link
              className="child-link"
              to={`/ind-health-insurance/${lang}`}
              onClick={() => closeMenu()}
            >
              <GroupYellowIcon /> {f("topbar.otherProducts")}
            </Link> */}

            <Link
              className="white-link"
              to={`/travel/${lang}`}
              onClick={() => closeMenu()}
            >
              {f("topbar.TravelInsurance")}
            </Link>
            <Link
              className="white-link"
              to={`/insurance-and-more/${lang}`}
              onClick={() => closeMenu()}
            >
              {f("topbar.InsuranceAndMore")}
            </Link>
          </div>

          <div className="dropdown-col">
            <h3>{f("topbar.forBusiness")}</h3>
            <Link
              className="white-link"
              to={`/corp-insurance/${lang}`}
              onClick={() => closeMenu()}
            >
              {f("topbar.HealthInsurance")}
            </Link>
          </div>

          <div className="dropdown-col">
            <h3>{f("topbar.forForeign")}</h3>
            <Link
              className="white-link"
              to={`/student/${lang}`}
              onClick={() => closeMenu()}
            >
              {f("topbar.ForeignStudentsInsurance")}
            </Link>
            <Link
              className="white-link"
              to={`/visitors-insurance/${lang}`}
              onClick={() => closeMenu()}
            >
              {f("topbar.InsideTravelInsurance")}
            </Link>
          </div>
        </div>
      )}
      {activeMenu === 2 && (
        <div
          className="header-dropdown remote-services-dropdown"
          ref={dropdownRef}
          onMouseLeave={closeMenu}
        >
          <div className="dropdown-col">
            <Link
              className="white-link"
              to={`${profileLink}profile-doctor/${lang}`}
              onClick={() => closeMenu()}
            >
              {f("topbar.FamilyReservationToDoc")}
            </Link>
            <Link
              className="white-link"
              to={`${profileLink}compensations/${lang}`}
              onClick={() => closeMenu()}
            >
              {f("main.claimForReimbursement")}
            </Link>
            <Link
              className="white-link"
              to={`${profileLink}appeals/${lang}`}
              onClick={() => closeMenu()}
            >
              {f("main.distantCalls")}
            </Link>
            {/* <Link
              className="white-link"
              to={`/chat-bot/${lang}`}
            >
              {f("topbar.ImedilBot")}
            </Link> */}
          </div>
          <div className="dropdown-col">
            <a
              className="yellow-link"
              href={`https://www.facebook.com/imediL?mibextid=LQQJ4d`}
              target="_blank"
            >
              {f("topbar.ImedilBot")}
            </a>
          </div>
        </div>
      )}
    </>
  );
};
export default DesktopMenuOptions;
